import { render, staticRenderFns } from "./SendInvoiceModal.vue?vue&type=template&id=4358c81c&"
import script from "./SendInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./SendInvoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports